module.exports = __webpack_public_path__ + "static/media/shift_booked.078a8da0.svg";